
import '../../App.css';
import unab from '../../img/svg/unab.svg'

function Header({page}) {

return (
	<header id="main_header" className={"marquee"}>
			<div class="in">
				<div class="maxwidth">
					<div class="logo"><img alt="" src={unab} /></div>
					<div class="ttl gone"></div>
					<div class="air gone"></div>
				</div>
			</div>
    </header>
);
}

export default Header;
